import React from 'react'
import "./BoostCard.css"

const cardContent = [
    "Identify predispositions to chronic conditions",
    "Optimize nutrition, fitness, and supplement plans",
    "Tailor medication choices to genetic compatibility",
    "Enable earlier and more accurate health interventions",
]

function BoostCard({
    cardContentProp=cardContent
}) {
  return (
    <div className='BoostCard-container standard-padding-spacer'>
        <div className='container py-5 mt-5'>
            <div className='row gy-4 justify-content-center'>
                {
                    cardContentProp.map((ele)=>{
                        return(
                            <div className='col-lg-6 p-3 px-5'>
                                <div className='box d-flex align-items-center gap-3 px-4 py-3 h-100'>
                                    <img src='/images/icons/iv-heart-icon.png' style={{borderRadius:"50%",width:"50px"}}/>
                                    <p className='body-paragraph mb-0' style={{fontSize:"1.3rem"}}>{ele}</p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    </div>
  )
}

export default BoostCard